
export type ShoppingPathJointReportValueObject = {
    id: bigint
    shoppingPathJointId: bigint
    shoppingPathJointReportReasonId: bigint
    userId: bigint
    createdAt: Date
}

export namespace ShoppingPathJointReportValueObject {
    export function construct(o: any): ShoppingPathJointReportValueObject {
        return {
            id: BigInt(o.id),
            shoppingPathJointId: BigInt(o.shoppingPathJointId),
            shoppingPathJointReportReasonId: BigInt(o.shoppingPathJointReportReasonId),
            userId: BigInt(o.userId),
            createdAt: new Date(o.createdAt),
        }
    }

    export const description: Record<keyof ShoppingPathJointReportValueObject, string> = {
        id: 'ID',
        shoppingPathJointId: '쇼핑경로 Joint ID',
        shoppingPathJointReportReasonId: '문의사항 ID',
        userId: '사용자 ID',
        createdAt: '생성 시각',
    }
}